export default {
  state: {
    showAsapSubmit: false,
    sequenceID: '',
    asapRequest: {
      show: false,
      data: '',
      customer: ''
    }
  },
  mutations: {
    setShowAsapSubmit (state, value) { state.showAsapSubmit = value },
    setSequenceID (state, value) { state.sequenceID = value },
    setAsapModal (state, value) { state.asapRequest.show = value },
    setAsapData (state, value) { state.asapRequest.data = value },
    setAsapCustomer (state, value) { state.asapRequest.customer = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/asap.js